export const arrayObjectCategories = [
    {
        data: "BAHAN BAKU UTAMA"
    },
    {
        data: "BAHAN PENUNJANG"
    },
    {
        data: "MECHANICAL ELECTRICAL PLUMBING"
    },
    {
        data: "HARDWARE AND APPLIANCES"
    },
    {
        data: "FINISHING MATERIAL"
    },
    {
        data: "OTHER"
    },
    {
        data: "PACKING MATERIAL"
    },
    {
        data: "CLEANING TOOLS"
    },
]